import React, { useState, useEffect, useCallback } from 'react';
import DataTableNativeML from '@/components/DataTableNativeML/DataTableNativeML';
// import webStorage from '@/utils/storageManager';
// import { COUPONSTATUS, COUPONTYPE } from '@/constants';
import { useIntl } from 'umi';
import { useSelector, useDispatch } from 'dva';
import CouponRecordStyled from './CouponRecordStyled';

const CouponRecord = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  // const DICTOBJ = webStorage.get('DICTOBJ');
  const { params = {} } = props || {};
  const { id } = params || {};
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ml/getCouponRecordList'];

  //获取优惠券记录列表
  const datas = useSelector((state) => state.ml.couponRecordList);
  console.log('couponRecordList', datas);
  const { total, data: dataList } = datas || {};
  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });
  const fetchCouponRecordList = useCallback(() => {
    if (id) {
      dispatch({
        type: 'ml/getCouponRecordList',
        payload: {
          values: {
            pageSize: pageData.pageSize,
            pageNum: pageData.pageNum,
            memberId: id,
          },
        },
      });
    }
  }, [dispatch, pageData.pageSize, pageData.pageNum, id]);
  useEffect(() => {
    fetchCouponRecordList();
  }, [fetchCouponRecordList]);

  const columns = [
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl01' }),
      id: 'couponName',
      key: 'couponName',
      align: 'center',
      // render: () => {},
    },

    // {
    //   title: '优惠券ID',
    //   align: 'center',
    //   id: 'couponType',
    //   key: 'couponType',
    //   // render: (text) => optionToKey(bindTypeMap, text),
    // },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl02' }),
      align: 'center',
      id: 'couponType',
      key: 'couponType',
      // render: ({ couponType }) => {
      //   return COUPONTYPE.find((i) => i.value === couponType)?.name;
      // },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl03' }),
      align: 'center',
      id: 'discountDesc',
      key: 'discountDesc',
      // render: ({ couponType }) => {
      //   return COUPONTYPE.find((i) => i.value === couponType)?.name;
      // },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl04' }),
      align: 'center',
      id: 'couponCode',
      key: 'couponCode',
      // render: (text) => optionToKey(bindTypeMap, text),
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl05' }),
      align: 'center',
      id: 'status',
      key: 'status',
      // render: ({ status }) => {
      //   return COUPONSTATUS.find((i) => i.value === status)?.name;
      // },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl06' }),
      align: 'center',
      id: 'sendTime',
      key: 'sendTime',
      // render: (text) => optionToKey(bindTypeMap, text),
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl07' }),
      align: 'center',
      id: 'receiveTime',
      key: 'receiveTime',
      // render: (text) => optionToKey(bindTypeMap, text),
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl08' }),
      align: 'center',
      id: 'endTime',
      key: 'endTime',
      // render: (text) => optionToKey(bindTypeMap, text),
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl09' }),
      align: 'center',
      id: 'consumeTime',
      key: 'consumeTime',
      // render: (text) => optionToKey(bindTypeMap, text),
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c05.lbl10' }),
      align: 'center',
      id: 'createBy',
      key: 'createBy',
      render: ({ createBy }) => (createBy ? createBy : '--'),
    },
  ];
  return (
    <CouponRecordStyled>
      <DataTableNativeML
        columns={columns}
        loading={loading}
        paging={true}
        // pageButton={false}
        total={total}
        // title="会员列表"
        // columns={columns}
        page={{
          ...pageData,
          total: total,
        }}
        // buttonTitle={[{ text: '新增', onClick: edit }]}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={dataList}
        columnKey="id"
      ></DataTableNativeML>
    </CouponRecordStyled>
  );
};
export default CouponRecord;
